import { render, staticRenderFns } from "./PasswordRecoverySuccess.vue?vue&type=template&id=5bb4bc9a&scoped=true&"
import script from "./PasswordRecoverySuccess.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoverySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4bc9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
